const url = "https://becca-mastermind.herokuapp.com/";
//const url = "http://127.0.0.1:5000//";

const Constants = {
  url,
};

export default Constants;
